export default __webpack_public_path__ + "static/media/right-date.6f51957e.svg";